import axios from 'axios'
import qs from 'qs'

// 默认配置
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL
// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

// 请求拦截器
axios.interceptors.request.use(
  config => {
    if (config.method === 'post' && config.url !== '/news/list' && config.url !== '/news_type/list') {
      // config.data = qs.stringify(config.data)
    }
    return config
  },
  error => {
    return console.log(error)
  }
)

// 响应拦截器
axios.interceptors.response.use(
  config => {
    config = config.data
    return config
  },
  error => {
    // alert('接口异常')
    return console.log(error)
  }
)

export const instance = axios.create({})
export default axios